import React, { Component } from "react";
import { Menu, Visibility } from "semantic-ui-react";
import { withTranslation } from "react-i18next";
import "../containers/styles/common.css";
import { colors } from "@material-ui/core";

const menuStyle = {
  border: "grove #E0E0E0",
  borderRadius: 0,
  transition: "box-shadow 0.3s ease, padding 0.3s ease",
  backgroundColor: "#FFFFFF",
  height: "80px",
  width: "100%",
};

const fixedMenuStyle = {
  backgroundColor: "#FFF",
  border: "1px solid #ddd",
  boxShadow: "0px 3px 5px rgba(0, 0, 0, 0.2)",
  height: "60px",
  paddingLeft: "50px",
};

class HeadDetailReservation extends Component {
  state = {
    menuFixed: false,
    overlayFixed: false,
  };

  stickOverlay = () => this.setState({ overlayFixed: true });

  stickTopMenu = () => this.setState({ menuFixed: true });

  unStickOverlay = () => this.setState({ overlayFixed: false });

  unStickTopMenu = () => this.setState({ menuFixed: false });

  render() {
    const { menuFixed } = this.state;
    const { t } = this.props;

    return (
      <div>
        <Visibility
          onBottomPassed={this.stickTopMenu}
          onBottomVisible={this.unStickTopMenu}
          once={false}
        >
          
          <Menu
            borderless
            compact
            style={
              (menuFixed ? fixedMenuStyle : menuStyle,
              {
                display: "flex",
                padding: "0 25px 0 25px",
                justifyContent: "space-between",
                backgroundColor: "#3f83c2",
                color: "white",
                fontWeight: "bold",
              })
            }
          >
            <div className="flex flex-col md:flex-row gap-2 justify-center items-center">
              <p className="mb-0">{t("reservation_date") + ":"}</p>
              <p>{this.props.reservation_date}</p>
            </div>
            <div className="flex flex-col md:flex-row gap-2 justify-center items-center">
              <p className="mb-0">{t("reservation_agency") + ":"}</p>
              <p>{this.props.reservation_agency}</p>
            </div>
            <div className="flex flex-col md:flex-row gap-2 justify-center items-center">
              <p className="mb-0">{t("reservation_executive") + ":"}</p>
              <p>{this.props.reservation_executive}</p>
            </div>
            <div className="flex flex-col md:flex-row gap-2 justify-center items-center">
              <p className="mb-0">{t("reservation_type") + ":"}</p>
              <p>{this.props.reservation_type}</p>
            </div>
           
            
          </Menu>
        </Visibility>
      </div>
    );
  }
}

export default withTranslation()(HeadDetailReservation);
